import { render, staticRenderFns } from "./companyconfiguration.vue?vue&type=template&id=41dc9bee&"
import script from "./companyconfiguration.vue?vue&type=script&lang=js&"
export * from "./companyconfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports